// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_12F5LWh6w70-igM4AuZtpw","container":"_3fUV__7zp2bV3_l2h34FkL","headerTitle":"_2AQ0plC9k6CIS5YFGoGyD2","main":"uTmezJ7ABsQVYYuJ2fj4t"};